import React from 'react';
import { motion } from 'framer-motion';
const items = [{
  emoji: '😰',
  text: 'Se quedan pensando qué preguntar cuando el paciente guarda silencio.'
}, {
  emoji: '😓',
  text: 'Sienten que sus sesiones no logran profundizar lo suficiente.'
}, {
  emoji: '🤷‍♀️',
  text: 'Escuchan respuestas como “No sé”, “Todo bien” o “Normal” y no saben cómo continuar.'
}, {
  emoji: '🧠',
  text: 'Conocen mucha teoría, pero en sesión dudan sobre cuál es la mejor intervención.'
}, {
  emoji: '💬',
  text: 'Atienden pacientes resistentes, evitativos o emocionalmente bloqueados.'
}, {
  emoji: '😔',
  text: 'Terminan algunas consultas con la sensación de que pudieron haber hecho mucho más.'
}];
export function IdentifySection() {
  return <section className="bg-white px-4 py-14" data-id="element-144" data-mp="1nbsltdync89e">
      <div className="mx-auto max-w-md text-center" data-id="element-145" data-mp="3cpxim5527dwk">
        <h2 className="font-display text-3xl font-bold leading-tight text-plum" data-id="element-146" data-mp="3hnyzqkixd35e">
          ¿Te ha pasado alguna de estas situaciones?
        </h2>
        <p className="mt-3 text-[15px] text-plum/70" data-id="element-147" data-mp="s4zxv765fbxk">Este sistema fue creado para terapeutas que…</p>

        <div className="mt-7 space-y-3 text-left" data-id="element-148" data-mp="n65dw1wg3hbv">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.04
        }} className="flex items-start gap-3 rounded-2xl bg-[#faf6fb] p-4" data-id="element-149" data-mp="10xa5cgpnt3b4" data-mpi={i}>
              <span className="text-2xl leading-none" data-id="element-150" data-mp="49ngb3ux0n7p">{item.emoji}</span>
              <span className="text-sm font-medium text-plum/80" data-id="element-151" data-mp="i83tndna9byt">{item.text}</span>
            </motion.div>)}
        </div>

        <p className="mt-7 text-[15px] font-semibold leading-relaxed text-plum" data-id="element-152" data-mp="d7fto2h2tksg">
          Si te identificaste con una sola de estas situaciones…{' '}
          <span className="text-magenta" data-id="element-153" data-mp="1oofmcz7c61n0">este sistema fue diseñado para ti.</span>
        </p>
      </div>
    </section>;
}